/**
 * Se avisa en `window` cada vez que un cambio (POST, PUT, PATCH, DELETE o una subida) sale bien,
 * para que lo que depende de los datos, como la barra de estado (2.25), se vuelva a leer sola.
 * Vive aparte de `api.ts` para que las pruebas que simulan el API no lo pierdan.
 */
export const EVENTO_CAMBIO = 'plataforma:cambio';

export function avisarCambio() {
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(EVENTO_CAMBIO));
}
